"use client";

import { useEffect } from "react";
import { ErrorPage } from "skedyul-ui/ui";

export default function WorkplaceError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Workplace route error boundary:", error);
  }, [error]);

  return (
    <ErrorPage
      className="h-full min-h-full"
      digest={
        process.env.NODE_ENV !== "production" ? error.digest : undefined
      }
      primaryAction={{
        label: "Try again",
        onClick: () => {
          reset();
        },
      }}
      secondaryAction={{
        label: "Go to home",
        onClick: () => {
          window.location.assign("/");
        },
      }}
    />
  );
}
